import UserService from "app/services/userService";

import Label from "components/Label/Label";
import { DeleteIcon, EditIcon } from "components/icons";
import { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import Radio from "shared/Radio/Radio";
import Select from "shared/Select/Select";
export interface PropsAddress {
  id?: number;
  firstname: string;
  lastname: string;
  phone: string;
  address: string;
  city: string;
  country: string;
  postal_code: string;
  wilaya: string;
  default: boolean;
}

interface Props {
  isActive: boolean;
  onCloseActive: () => void;
  onOpenActive: () => void;
  onSetAddress: (address: PropsAddress) => void;
}

const Address = {
  firstname: "",
  lastname: "",
  phone: "",
  address: "",
  city: "",
  country: "Algérie",
  postal_code: "",
  wilaya: "",
  default: false,
};
const ShippingAddress: FC<Props> = ({
  isActive,
  onCloseActive,
  onOpenActive,
  onSetAddress,
}) => {
  const [addresses, setAddresses] = useState<PropsAddress[]>([]);
  const [address, setAddress] = useState<PropsAddress>(Address);
  const [selectedAddress, setSelectedAddress] = useState<PropsAddress>();
  useEffect(() => {
    UserService.getAddress()
      .then((data) => {
        setAddresses(data);
        // setAddress(data)
        // onSetAddress(data)
        console.log("adress", data);
      })
      .catch((r) => {
        // console.log(r)
      });
  }, []);

  const addAddressHandler = () => {
    UserService.addAddress(address)
      .then((data) => {
        console.log(data);
      })
      .catch((e) => {});
    // onCloseActive()
  };
  const updateAddress = () => {
    // onCloseActive()
  };
  const handleChange = (event: any) => {
    const { name, value } = event.target;

    setAddress((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const chnageAddress = (a: PropsAddress) => {
    a.default = true;
    UserService.addAddress(a)
      .then((data) => {
        console.log("data", data);
      })
      .catch((e) => {});
    console.log(a);
    setSelectedAddress(a);
  };
  const renderAddressesList = () => {
    const active = "Cash-on-delivery";
    return (
      <>
        {addresses
          ? addresses.map((a, i) => {
              return (
                <div
                  key={i}
                  className="flex items-start space-x-4 sm:space-x-6"
                >
                  <Radio
                    className="pt-3.5"
                    name="payment-method"
                    id={`address-${a.id}`}
                    defaultChecked={a.default}
                    onChange={(e) => {
                      chnageAddress(a);
                    }}
                  />
                  <div className="flex-1">
                    <div className="flex justify-between">
                      <label
                        htmlFor={`address-${a.id}`}
                        className="flex items-center space-x-4 sm:space-x-6"
                      >
                        <p className="font-medium">
                          {a.firstname} {a.lastname}
                        </p>
                      </label>
                      <div className="flex">
                        <EditIcon className="cursor-pointer"></EditIcon>
                        <DeleteIcon></DeleteIcon>
                      </div>
                    </div>

                    <div className={` mb-1 ${active ? "block" : "hidden"}`}>
                      <p className="text-sm dark:text-slate-300">
                        {a.address} {a.postal_code} {a.city},
                      </p>
                      <p>
                        {a.wilaya}, {a.country}
                      </p>
                      <p>{a.phone} </p>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </>
    );
  };
  const addAddress = () => {
    return (
      <>
        {/* ============ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
          <div>
            <Label className="text-sm">Votre Prénom</Label>
            <Input
              className="mt-1.5"
              value={address.firstname}
              name="firstname"
              onChange={handleChange}
            />
          </div>
          <div>
            <Label className="text-sm">Votre Nom</Label>
            <Input
              className="mt-1.5"
              defaultValue={address.lastname}
              name="lastname"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="sm:flex space-y-4 sm:space-y-0 sm:space-x-3">
          <div className="flex-1">
            <Label className="text-sm">Numéro de téléphone</Label>
            <Input
              className="mt-1.5"
              placeholder=""
              defaultValue={address.phone}
              type={"text"}
              name="phone"
              onChange={handleChange}
            />
          </div>
        </div>

        {/* ============ */}
        <div className="sm:flex space-y-4 sm:space-y-0 sm:space-x-3">
          <div className="flex-1">
            <Label className="text-sm">Adresse</Label>
            <Input
              className="mt-1.5"
              placeholder=""
              defaultValue={address.address}
              type={"text"}
              name="address"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
          <div>
            <Label className="text-sm">Ville</Label>
            <Input
              name="city"
              className="mt-1.5"
              defaultValue="Texas"
              onChange={handleChange}
            />
          </div>
          <div>
            <Label className="text-sm">Code Postal</Label>
            <Input
              className="mt-1.5"
              defaultValue={address.postal_code}
              name="postal_code"
              onChange={handleChange}
            />
          </div>
        </div>
        {/* ============ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
          <div>
            <Label className="text-sm">Wilaya</Label>
            <Input
              className="mt-1.5"
              defaultValue={address.wilaya}
              name="wilaya"
              onChange={handleChange}
            />
          </div>
          <div>
            <Label className="text-sm">Pays</Label>
            <Select
              name="country"
              className="mt-1.5"
              defaultValue="Algérie"
              onChange={handleChange}
            >
              <option value="Algérie">Algérie</option>
            </Select>
          </div>
        </div>

        {/* ============ */}
        <div className="flex flex-col sm:flex-row pt-6">
          <ButtonPrimary
            className="sm:!px-7 shadow-none"
            onClick={addAddressHandler}
          >
            Enregistrer
          </ButtonPrimary>
          <ButtonSecondary
            className="mt-3 sm:mt-0 sm:ml-3"
            onClick={onCloseActive}
          >
            Annuler
          </ButtonSecondary>
        </div>
      </>
    );
  };
  return (
    <div className="border border-slate-200 dark:border-slate-700 rounded-xl ">
      <div className="p-6 flex flex-col sm:flex-row items-start">
        <span className="hidden sm:block">
          <svg
            className="w-6 h-6 text-slate-700 dark:text-slate-400 mt-0.5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.1401 15.0701V13.11C12.1401 10.59 14.1801 8.54004 16.7101 8.54004H18.6701"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.62012 8.55005H7.58014C10.1001 8.55005 12.1501 10.59 12.1501 13.12V13.7701V17.25"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.14008 6.75L5.34009 8.55L7.14008 10.35"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.8601 6.75L18.6601 8.55L16.8601 10.35"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>

        <div className="sm:ml-8">
          <h3 className=" text-slate-700 dark:text-slate-300 flex ">
            <span className="uppercase">ADRESSE DE LIVRAISON</span>
            <svg
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.5"
              stroke="currentColor"
              className="w-5 h-5 ml-3 text-slate-900 dark:text-slate-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          </h3>
          <div className="font-semibold mt-1 text-sm">
            <span className="">
              {selectedAddress?.address} {selectedAddress?.wilaya}{" "}
              {selectedAddress?.postal_code}
            </span>
          </div>
        </div>
        <ButtonSecondary
          sizeClass="py-2 px-4 "
          fontSize="text-sm font-medium"
          className="bg-slate-50 dark:bg-slate-800 mt-5 sm:mt-0 sm:ml-auto !rounded-lg"
          onClick={onOpenActive}
        >
          Changer
        </ButtonSecondary>
      </div>
      <div
        className={`border-t border-slate-200 dark:border-slate-700 px-6 py-7 space-y-4 sm:space-y-6 ${
          isActive ? "block" : "hidden"
        }`}
      >
        {addresses.length ? renderAddressesList() : addAddress()}

        {/* ============ */}
        <div className="flex flex-col sm:flex-row pt-6">
          <ButtonPrimary
            className="sm:!px-7 shadow-none"
            onClick={onCloseActive}
          >
            Enregistrer
          </ButtonPrimary>
          <ButtonSecondary
            className="mt-3 sm:mt-0 sm:ml-3"
            onClick={onCloseActive}
          >
            Annuler
          </ButtonSecondary>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddress;
